import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Category } from '../../../../../core/model';

@Component({
  selector: 'py-price-file-category-list',
  templateUrl: './price-file-category-list.component.html',
  standalone: false,
})
export class PriceFileCategoryListComponent implements OnInit {
  @Input()
  categories: Array<Category>;

  @Input()
  previewIndices: Array<number>;

  @Input()
  disabled? = true;

  @Input()
  collapsed? = true;

  @Input()
  selectedCategories = [];

  @Output()
  selected = new EventEmitter<Array<Category>>();

  constructor() {}

  ngOnInit(): void {}

  toggleCategories() {
    this.collapsed = !this.collapsed;
  }

  remaining() {
    return `+${this.categories.length - this.previewIndices.length}`;
  }

  pick($event: boolean, category: Category) {
    if (!this.disabled) {
      if ($event) {
        this.selectedCategories = [...this.selectedCategories, category];
      } else {
        this.selectedCategories = this.selectedCategories.filter((c) => c.code !== category.code);
      }
      this.selected.emit(this.selectedCategories);
    }
  }

  isPicked(category: Category): boolean {
    return !!this.selectedCategories.find((c) => c.code === category.code);
  }
}
